// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__1jiro","errorText":"Error_errorText__FanCk"};